import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader';
import ClientEnvironmentModal from './ClientEnvironmentModal';
import ClientEnvironmentGrid from './ClientEnvironmentGrid';
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import axios from 'axios';
import { getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getModulePermissions } from '../../utils/permissionHelper';
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles';

function ClientEnvironmentMain(props) {
  const [getClientEnvironmentList, setClientEnvironmentList] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [alert, setAlert] = useState(null);
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  
  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
    setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchClientEnvironment();
  }, []);

  function openAddModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }
  async function onSubmit(e, data) {
    if (e.target.name === "Add") {
      const ClientEnvironmentModel = data;
      if(ClientEnvironmentModel){
        let ClientEnvironmentDetails = {
          ClientId: null,
          Name: ClientEnvironmentModel.Name ? ClientEnvironmentModel.Name : "",
          ClientUrl: ClientEnvironmentModel.ClientUrl ? ClientEnvironmentModel.ClientUrl : "",
          PortNumber: ClientEnvironmentModel.PortNumber !== undefined && ClientEnvironmentModel.PortNumber !== null && `${ClientEnvironmentModel.PortNumber}`.trim() !== "" ? Number(ClientEnvironmentModel.PortNumber) : null,
          BranchName: ClientEnvironmentModel.BranchName ? ClientEnvironmentModel.BranchName : "",
          DatabaseName: ClientEnvironmentModel.DatabaseName ? ClientEnvironmentModel.DatabaseName : "",
          APIUrl: ClientEnvironmentModel.APIUrl ? ClientEnvironmentModel.APIUrl : "",
          FaviconPath: ClientEnvironmentModel.FaviconPath ? ClientEnvironmentModel.FaviconPath : "",
          WebsiteFolder: ClientEnvironmentModel.WebsiteFolder ? ClientEnvironmentModel.WebsiteFolder : null,
          ApplicationId: ClientEnvironmentModel.ApplicationId !== undefined && ClientEnvironmentModel.ApplicationId !== null && `${ClientEnvironmentModel.ApplicationId}`.trim() !== "" ? Number(ClientEnvironmentModel.ApplicationId) : null,
          UserId: getStorageValues('userId')
        };
        if (validation(ClientEnvironmentDetails)) {
          try {
            const response = await axios.post(
              getApiBaseUrl() + "/saveClientEnvironmentDetails",
              ClientEnvironmentDetails
            );
            if (response.status === 200) {
              if(response.data.data[0].success === 1){
                CreateAlert(response.data.data[0].message, "Success", setAlert);
                fetchClientEnvironment();
                closeModal();
              } else {
                CreateAlert(response.data.data[0].message, "Error", setAlert);
              }
            } 
          } catch (error) {
            console.log(error);
          }
        }
      } else {
        CreateAlert("Fields marked with an asterisk (*) are required!!", "Error", setAlert);
      }
    } 
  }
  function validation(ClientEnvironmentDetails) {
    var validation = true;
    if (ClientEnvironmentDetails) {
      if (ClientEnvironmentDetails.Name !== null | undefined) {
        if (ClientEnvironmentDetails.Name.length === 0) {
          CreateAlert("Please enter client name!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter client name!!", "Warning", setAlert);
        validation = false;
        return;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      validation = false;
      return;
    }
    return validation;
  }
  const fetchClientEnvironment = async () => {
    try {
      let ClientEnvironmentDetails = {
        UserId: getStorageValues('userId')
      };
      const response = await axios.get(getApiBaseUrl() + "/clientEnvironmentList", ClientEnvironmentDetails);
      if (response.status === 200) {
        setClientEnvironmentList(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleExportExcel = () => {
    const columns = [
      { name: "Client Name", selector: "Name" },
      { name: "Client Url", selector: "ClientUrl" },
    ];
    exportToExcel("ClientEnvironments", columns, getClientEnvironmentList);
  };
  
  const handleExportPDF = () => {
    const columns = [
      { name: "Client Name", selector: "Name" },
      { name: "Client Url", selector: "ClientUrl" },
    ];
    exportToPDF("ClientEnvironments", columns, getClientEnvironmentList);
  };
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal} 
        onRefresh={fetchClientEnvironment}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
      />
      <ClientEnvironmentGrid ClientEnvironmentData={getClientEnvironmentList} fetchClientEnvironment={fetchClientEnvironment} UserPermissions={getUserModulePermission}/>
      <ClientEnvironmentModal
        show={modalIsOpen}
        UserAction={"Add"}
        onClose={closeModal}
        onSubmit={onSubmit}

      />
    </>
  )
}

export default ClientEnvironmentMain